var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"px-gen py-2 web-service mx-0"},[_c('h3',{staticClass:"ui dividing header fdinpro is-uppercase"},[_vm._v(" SISTEMAS ACTIVOS ")]),_c('p',{},[_c('i',{staticClass:"circle icon web-service-icon",class:{ active: _vm.is_web_service_enabled }}),_vm._v("WebService (API) ")])])
}
var staticRenderFns = []

export { render, staticRenderFns }